<script context="module" lang="ts">
    export const cssClasses = [
        "width-1000px",
        "width-full",
        "width-75percent",
        "width-60percent",
        "width-50percent",
        "width-40percent",
        "width-33percent",
        "width-25percent",
        "min-width-400px",
        "min-width-500px",
        "min-width-600px",
        "min-width-250px",
        "min-width-400px",
        "min-width-500px",
        "min-width-600px",
        "breakPoint-1000px",
        "breakPoint-800px",
        "breakPoint-600px",
        "carousel",
    ];
</script>

<script lang="ts">
    import Carousel from "./Carousel.svelte";
    export let data: any = {};
    export let id: string;

    const isCarousel =
        data.cssClasses && data.cssClasses.indexOf("carousel") !== -1;
</script>

{#if isCarousel}
    <Carousel {id}><slot /></Carousel>
{:else}
    <slot />
{/if}

<style lang="scss">
    :global {
        .blockContainer-width-full {
            width: 100% !important;
            margin-bottom: 10px;
        }

        .blockContainer-min-width-400px {
            min-width: 400px !important;
        }

        .blockContainer-min-width-600px {
            min-width: 600px !important;
        }

        .blockContainer-min-width-500px {
            min-width: 500px !important;
        }

        .blockContainer-width-1000px {
            width: 1000px !important;
            margin: auto auto 10px auto;
        }

        .blockContainer-width-60percent {
            width: 60% !important;
            margin: auto;
        }

        .blockContainer-width-75percent {
            width: 75% !important;
            margin: auto;
        }

        .blockContainer-width-50percent {
            width: 50% !important;
            margin: auto;
        }

        .blockContainer-width-40percent {
            width: 40% !important;
            margin: auto;
        }

        .blockContainer-width-33percent {
            width: 33% !important;
            margin: auto;
        }

        .blockContainer-width-25percent {
            width: 25% !important;
            margin: auto;
        }

        .blockContainer-carousel {
            width: 100% !important;
            margin-bottom: 10px;
            height: auto;
            flex-direction: row !important;
            overflow-x: scroll;
            overflow-y: hidden;
            flex-wrap: nowrap !important;
        }

        .blockContainer-min-width-250px {
            min-width: 250px !important;
        }

        .blockContainer-min-width-400px {
            min-width: 400px !important;
        }

        .blockContainer-min-width-600px {
            min-width: 600px !important;
        }

        .blockContainer-min-width-500px {
            min-width: 500px !important;
        }

        @media only screen and (max-width: 1000px) {
            :global {
                .blockContainer-breakPoint-1000px {
                    width: calc(
                        100% - var(--containerPadding, "10px") * 2
                    ) !important;
                    min-width: calc(
                        100% - var(--containerPadding, "10px") * 2
                    ) !important;
                    position: relative !important;
                }
            }
        }

        @media only screen and (max-width: 800px) {
            :global {
                .blockContainer-breakPoint-800px {
                    width: calc(
                        100% - var(--containerPadding, "10px") * 2
                    ) !important;
                    min-width: calc(
                        100% - var(--containerPadding, "10px") * 2
                    ) !important;
                    position: relative !important;
                }
            }
        }

        @media only screen and (max-width: 600px) {
            :global {
                .blockContainer-breakPoint-600px {
                    width: calc(
                        100% - var(--containerPadding, "10px") * 2
                    ) !important;
                    min-width: calc(
                        100% - var(--containerPadding, "10px") * 2
                    ) !important;
                    position: relative !important;
                    flex-direction: column !important;
                }
            }
        }
    }

    @media only screen and (max-width: 1000px) {
        :global {
            .blockContainer-min-width-400px,
            .blockContainer-min-width-500px,
            .blockContainer-min-width-600px {
                width: 100% !important;
                min-width: 100% !important;
            }
        }
    }

    @media only screen and (max-width: 1000px) {
        :global(.blockContainer-width-1000px) {
            width: calc(100% - 20px) !important;
            margin: auto;
            padding: 10px;
        }
    }
</style>
